import { CSS } from '@grupoboticario/flora-react'

export const menuContainerCss: CSS = {
  width: '232px'
}

export const getSidebarCss = (openMenu: boolean): CSS => ({
  background: '$actionableDefault',
  bottom: 0,
  height: '100vh',
  left: openMenu ? 0 : '-100%',
  overflowY: 'auto',
  position: 'fixed',
  transition: '0.3s ease-in-out',
  top: 0,
  width: '232px',
  zIndex: '$overlay',
  '@fullscreen': {
    left: 0
  }
})

export const logoHeaderCss: CSS = {
  padding: '$6 0 $4',
  position: 'relative',
  textAlign: 'center'
}

export const closeButtonCss: CSS = {
  background: 'none',
  border: 0,
  fontSize: 0,
  right: '$2',
  position: 'absolute',
  top: '$3',
  '@fullscreen': {
    display: 'none'
  }
}

export const logoVisibilityCss: CSS = {
  visibility: 'hidden',
  '@fullscreen': {
    visibility: 'visible'
  }
}

export const logoImageCss: CSS = {
  cursor: 'pointer'
}

export const separatorCss: CSS = {
  margin: '$5 auto 0',
  width: '200px'
}

export const scrollableContentCss: CSS = {
  flex: '1',
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    width: '6px'
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent'
  },
  '&::-webkit-scrollbar-thumb': {
    background: '$actionNavigationAltHighlight'
  }
}

export const accordionCss: CSS = {
  width: '100%'
}

export const footerCss: CSS = {
  height: '118px'
}

export const footerSeparatorCss: CSS = {
  marginBottom: '$4',
  width: '200px'
}

export const footerContentCss: CSS = {
  padding: '0 $4'
}

export const footerTextColorCss: CSS = {
  color: '$actionableAlt'
}

export const footerLogoutRowCss: CSS = {
  marginTop: '$2'
}

export const logoutTextCss: CSS = {
  cursor: 'pointer'
}

export const getAccordionButtonCss = (isActive: boolean, hasSubLinks: boolean): CSS => ({
  borderTop: '0 !important',
  padding: '0 $4',
  width: '100%',
  ...(isActive && {
    background: '$actionableHover !important'
  }),
  svg: {
    fill: '$actionableAlt !important'
  },
  span: {
    '&[data-accordion-arrow]': {
      display: hasSubLinks ? 'block' : 'none'
    }
  }
})

export const getMenuItemFlexCss = (hasPermissionValue: boolean, icon: string): CSS => ({
  color: hasPermissionValue ? '$colors$actionableAlt' : '$colors$statusInfoNonInteractiveOutline',
  paddingLeft: '$6',
  position: 'relative',
  '&::before': {
    content: `url(${icon})`,
    height: '24px',
    left: 0,
    position: 'absolute',
    ...(!hasPermissionValue && {
      filter: 'invert(40%) sepia(57%) saturate(23%) hue-rotate(247deg) brightness(111%) contrast(95%)'
    })
  }
})

export const menuItemTextCss: CSS = {
  textAlign: 'left',
  lineHeight: '$5',
  marginLeft: '$2'
}

export const accordionPanelCss: CSS = {
  padding: '0'
}

export const getSubMenuItemBoxCss = (hasPermissionValue: boolean): CSS => ({
  cursor: hasPermissionValue ? 'pointer' : undefined,
  padding: '$2 0 $2 $5',
  '&:hover, &[data-active="true"]': {
    background: '$actionableHover'
  }
})

export const getSubMenuItemTextCss = (hasPermissionValue: boolean): CSS => ({
  color: hasPermissionValue ? '$nonInteractiveAltPredominant' : '$nonInteractiveAuxiliar'
})
